<div *ngIf="status === 'waiting'; else errorProgressBar" class="bar-container">
  <div class="bar-waiting"></div>
</div>

<ng-template #errorProgressBar>
  <div class="bar-container" *ngIf="status === 'error' ;else trackingProgressBar">
    <div [style.width.%]="progress" class="bar bar-yellow"></div>
  </div>
</ng-template>

<ng-template #trackingProgressBar>
  <div class="bar-container" *ngIf="status === 'tracking' ;else normalProgressBar">
    <div [style.width.%]="progress" class="bar bar-yellow"></div>
  </div>
</ng-template>

<ng-template #normalProgressBar>
  <div class="bar-container">
    <div [style.width.%]="progress" class="bar bar-blue"></div>
  </div>
</ng-template>
